import React from 'react';
import { useAuthGuard } from '../../hooks/useAuthGuard';
import Loading from '../../pages/Loading';

interface AuthGuardProps {
  children: React.ReactNode;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { isChecking } = useAuthGuard();

  if (isChecking) {
    return <Loading />;
  }

  return <>{children}</>;
};

export default AuthGuard;
